import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=e8cf4abc&scoped=true&"
import script from "./safety.vue?vue&type=script&lang=js&"
export * from "./safety.vue?vue&type=script&lang=js&"
import style0 from "./safety.vue?vue&type=style&index=0&id=e8cf4abc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cf4abc",
  null
  
)

export default component.exports